"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlOptions = void 0;
var _normalizeSlashChars = require("./normalizeSlashChars");
/* eslint-disable import/no-deprecated -- utility for legacy usages */

/** @deprecated Use API instead if possible. */
const getUrlOptions = ({
  basePath: originalBasePath,
  queryParams,
  host: originalHost,
  ...rest
}) => {
  const basePath = (0, _normalizeSlashChars.normalizeSlashChars)(originalBasePath, true, false);
  const host = (0, _normalizeSlashChars.normalizeSlashChars)(originalHost ?? (typeof window === 'object' ? window.location.origin : ''), undefined, false);
  let query;
  if (typeof queryParams === 'object') {
    const params = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        params.append(key, String(value));
      }
    });
    query = `?${params.toString()}`;
  }
  const urlOptions = {
    ...rest,
    basePath,
    host,
    query
  };
  const cacheKeys = Object.values(urlOptions).map(item => String(item));
  return {
    cacheKeys,
    urlOptions
  };
};
exports.getUrlOptions = getUrlOptions;
